import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CheckoutService } from '../../services/checkout/checkout.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-tok-payment',
  templateUrl: './tok-payment.component.html',
  styleUrls: ['./tok-payment.component.scss']
})
export class TokPaymentComponent implements OnInit {
  
  petName: string = '';

  constructor(
    private checkoutService: CheckoutService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.petName = this.route.snapshot.queryParamMap.get('petName');
  }

  public buyTok() {
    this.checkoutService.checkout([environment.stripePlans.identiAlertTokBreeder]).subscribe();
  }
}
